<h3>{{ label }} <mandatory *ngIf="mandatory"></mandatory></h3>

<div class="row align-items-start ml-0 mt-2 w-100 pb-3">
    <dp-widget-builder-help-template-preview
        class="help-text-container d-block"
        [template]="form?.value"
    ></dp-widget-builder-help-template-preview>
    <div class="ml-auto mr-4 font-16px summary-icon"><fa-icon icon="facEdit" (click)="handleOpenEditModal()"></fa-icon></div>
</div>
